export default __webpack_public_path__ + "static/media/pluse.33bd4d45.svg";